/**
 * Header state: swap `#publicAuthBar` and `#userMenu` based on session, and
 * show the role-specific nav buttons (admin / institution / share recipient).
 *
 * Listing this as a separate module keeps `main.ts` focused on routing and
 * lets later milestones (M5+) add more nav buttons without touching the
 * bootstrap file.
 */
import { currentUser, clearSession } from '../state/session.ts';
import { t } from '../i18n/index.ts';

export function refreshHeader(): void {
  const user = currentUser();
  const publicBar = document.getElementById('publicAuthBar')!;
  const userMenu = document.getElementById('userMenu')!;

  if (!user) {
    publicBar.style.display = '';
    userMenu.style.display = 'none';
    return;
  }

  publicBar.style.display = 'none';
  userMenu.style.display = '';

  const nameEl = document.getElementById('userMenuName')!;
  const roleEl = document.getElementById('userMenuRole')!;
  nameEl.textContent = user.name || user.email;
  roleEl.textContent = roleLabel(user.role, user.level);

  // Admin-only entry — single "Käyttäjähallinta" button opens the M6.2
  // tabbed modal (mockup `#adminPanel`). The legacy per-queue buttons are
  // hidden so the header stays compact.
  const isAdmin = user.role === 'admin';
  const adminBtn = document.getElementById('adminMenuBtn');
  if (adminBtn) (adminBtn as HTMLElement).style.display = isAdmin ? '' : 'none';
  for (const id of ['adminOrdersBtn', 'adminFeedbackBtn', 'adminAuditBtn']) {
    const el = document.getElementById(id);
    if (el) (el as HTMLElement).style.display = 'none';
  }

  // Institution / Pro market overview (M6 work).
  const instBtn = document.getElementById('institutionBtn')!;
  instBtn.style.display = user.role === 'institution' || user.level >= 2 ? '' : 'none';

  // "Omat tilat" appears for everyone signed in (M5 share recipients land here).
  document.getElementById('myEstatesBtn')!.style.display = '';
}

function roleLabel(role: string, level: number): string {
  if (role === 'admin') return t('role_admin');
  if (role === 'institution') return t('role_institution');
  const clamped = Math.max(0, Math.min(level, 4));
  return t(`level_${clamped}`);
}

export function bindLogout(onAfter: () => void): void {
  document.getElementById('logoutBtn')!.addEventListener('click', () => {
    clearSession();
    onAfter();
  });
}
